import { InputHTMLAttributes } from 'react';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    error?: string;
}

const TextInput = ({ id, type = 'text', value, onChange, error, ...props }: Props) => (
    <input
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        className={`block w-full rounded border px-3 py-2.5 text-sm leading-5 placeholder-blue-steel transition duration-200 focus:border-gray focus:bg-white focus:outline-none focus:ring-0 disabled:bg-white-pearl ${
            error ? 'border-red bg-red-light' : 'border-gray bg-white'
        }`}
        {...props}
    />
);

export default TextInput;
